<!-- ======================== HEADER ======================== -->
<header class="cart-header">
  <div class="cart-header-inner">
    <button class="back" type="button" (click)="onVoltar()">
      <i class="pi pi-arrow-left"></i>
      <span>{{ 'cardapio_digital.carrinho.voltar' | translate }}</span>
    </button>

    <div class="sacola" *ngIf="itens.length > 0">
      <span class="sacola-label">{{ 'cardapio_digital.carrinho.sacola' | translate }}</span>
      <span class="sacola-total" [class.jello-horizontal]="animarTotal">{{ totalFormatado }}</span>
    </div>
  </div>
</header>

<!-- ======================== CARRINHO COM ITENS ======================== -->
<ng-container *ngIf="itens.length > 0; else emptyCart">
  <main class="cart-main">

    <!-- Lista de itens (cards verticais, estilo card de produto) -->
    <div class="cart-items-grid">
      <div class="cart-card"
           [class.scale-out-top]="removingItems.has(item)"
           *ngFor="let item of itens; trackBy: trackByItem">
        <!-- Imagem no topo (altura fixa, preenche o espaco) + selos -->
        <div class="cart-card-media">
          <ng-container *ngIf="imagemDoItem(item) as imagemItem; else semImagemItem">
            <img *ngIf="!urlComErro(imagemItem); else semImagemItem"
                 [src]="imagemItem" [alt]="item.produto.nome" class="cart-card-img" loading="lazy"
                 (error)="marcarUrlErro(imagemItem)" />
          </ng-container>
          <ng-template #semImagemItem>
            <div class="cart-card-img cart-card-img-placeholder">
              <i class="pi pi-image"></i>
            </div>
          </ng-template>

          <div class="cart-card-badges"
               *ngIf="item.produto.novidade || item.produto.promocao">
            <span *ngIf="item.produto.novidade" class="cart-badge cart-badge--icone badge-novidade"
                  [attr.aria-label]="'cardapio_digital.badge_novidade' | translate"
                  [pTooltip]="'cardapio_digital.badge_novidade' | translate" tooltipPosition="top">
              <i class="pi pi-star-fill"></i>
            </span>
            <span *ngIf="item.produto.promocao" class="cart-badge cart-badge--icone badge-promocao"
                  [attr.aria-label]="'cardapio_digital.badge_promocao' | translate"
                  [pTooltip]="'cardapio_digital.badge_promocao' | translate" tooltipPosition="top">
              <i class="fas fa-tag"></i>
            </span>
          </div>
        </div>

        <!-- Nome + opcoes + preco -->
        <div class="cart-card-info">
          <div class="cart-card-name">{{ item.nomeVariante ? item.produto.nome + ' - ' + item.nomeVariante : item.produto.nome }}</div>

          <ng-container *ngIf="formatarOpcoes(item) as opcoes">
            <div class="cart-card-opts" *ngFor="let opcao of opcoes; trackBy: trackByOpcao">
              <span>+ {{ opcao }}</span>
            </div>
          </ng-container>

          <div class="cart-card-opts" *ngIf="item.comentarios">
            <span>Obs: {{ item.comentarios }}</span>
          </div>

          <div class="cart-card-price">{{ formatarPrecoItem(precoUnitario(item)) }}</div>
        </div>

        <!-- Controles de quantidade (no lugar do rodape de id/compartilhar) -->
        <div class="cart-card-qty">
          <button
            *ngIf="item.quantidade === 1; else minusBtn"
            class="qty-btn danger"
            type="button"
            (click)="onRemover(item)">
            <i class="pi pi-trash"></i>
          </button>
          <ng-template #minusBtn>
            <button
              class="qty-btn"
              type="button"
              (click)="decrementarItem(item)">
              <i class="pi pi-minus"></i>
            </button>
          </ng-template>

          <span class="q">{{ item.quantidade }}</span>

          <button
            class="qty-btn"
            type="button"
            [disabled]="!podeIncrementarItem(item)"
            (click)="incrementarItem(item)">
            <i class="pi pi-plus"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- ======================== COMPLEMENTE SEU PEDIDO ======================== -->
    <section class="sugestoes-section" *ngIf="produtosSugeridos.length > 0">
      <h3 class="sugestoes-titulo">{{ 'cardapio_digital.carrinho.complemente' | translate }}</h3>

      <div class="sugestoes-scroll">
        <div class="sugestao-card"
             *ngFor="let produto of produtosSugeridos; trackBy: trackByProduto"
             (click)="onAdicionarProduto(produto)">
          <div class="sugestao-img-wrap">
            <img *ngIf="produto.foto && !urlComErro(produto.foto)" [src]="produto.foto" [alt]="produto.nome" class="sugestao-img" (error)="marcarUrlErro(produto.foto)" />
            <div *ngIf="!produto.foto || urlComErro(produto.foto)" class="sugestao-img sugestao-img-placeholder">
              <i class="pi pi-image"></i>
            </div>
            <!--
            O icone diz o que vai acontecer: "+" soma 1 direto ao carrinho (sem
            sair da tela), sliders abre o detalhe porque o produto exige escolha.
            Some quando nao ha saldo em estoque; o corpo do card continua
            abrindo o detalhe.
            -->
            <button
              *ngIf="!sugestoesSemEstoque.has(produto.id)"
              class="sugestao-add-btn"
              type="button"
              (click)="onAcaoSugestao($event, produto)"
              [attr.aria-label]="(sugestoesQueExigemConfiguracao.has(produto.id) ? 'cardapio_digital.escolher_opcoes' : 'cardapio_digital.adicionar_rapido') | translate"
              [title]="(sugestoesQueExigemConfiguracao.has(produto.id) ? 'cardapio_digital.escolher_opcoes' : 'cardapio_digital.adicionar_rapido') | translate">
              <i class="pi" [ngClass]="sugestoesQueExigemConfiguracao.has(produto.id) ? 'pi-sliders-h' : 'pi-plus'"></i>
            </button>
            <span class="sugestao-badge" *ngIf="calcularDesconto(produto) as desc">
              -{{ desc }}%
            </span>
          </div>
          <div class="sugestao-info">
            <span class="sugestao-nome">{{ produto.nome }}</span>
            <span class="sugestao-preco">{{ formatarPrecoItem(precoExibicao(produto)) }}</span>
          </div>
        </div>
      </div>
    </section>

  </main>
</ng-container>

<!-- ======================== CARRINHO VAZIO ======================== -->
<ng-template #emptyCart>
  <div class="empty-cart-message">
    <i class="pi pi-shopping-cart empty-cart-icon"></i>
    <p class="empty-cart-text">
      {{ 'cardapio_digital.carrinho.vazio' | translate }}
    </p>
    <button class="cta" type="button" (click)="onVoltar()">
      {{ 'cardapio_digital.carrinho.continuar_comprando' | translate }}
    </button>
  </div>
</ng-template>

<!-- ======================== FOOTER - TIPO DE SERVICO ======================== -->
<footer class="cart-footer" *ngIf="itens.length > 0">
  <div class="footer-label">{{ 'cardapio_digital.carrinho.selecione_tipo' | translate }}</div>

  <div class="tipo-servico-row">
    <button class="tipo-btn" type="button" (click)="onSelecionarTipo(TipoPedido.MESA)">
      <i class="pi pi-building"></i>
      <span>{{ 'cardapio_digital.carrinho.tipo_mesa' | translate }}</span>
    </button>

    <button class="tipo-btn" type="button" (click)="onSelecionarTipo(TipoPedido.RETIRADA)">
      <i class="pi pi-shopping-bag"></i>
      <span>{{ 'cardapio_digital.carrinho.tipo_retirada' | translate }}</span>
    </button>

    <button class="tipo-btn" type="button" (click)="onSelecionarTipo(TipoPedido.DELIVERY)">
      <i class="pi pi-car"></i>
      <span>{{ 'cardapio_digital.carrinho.tipo_delivery' | translate }}</span>
    </button>
  </div>

  <p class="termos-text">{{ 'cardapio_digital.carrinho.termos' | translate }}</p>
</footer>

<!-- ======================== MODAL DE IDENTIFICACAO ======================== -->
<p-dialog
  [(visible)]="modalIdentificacaoVisivel"
  [modal]="true"
  [closable]="true"
  [showHeader]="false"
  styleClass="cardapio-dialog"
  [style]="{ width: 'min(400px, 92vw)', borderRadius: '16px' }"
  [contentStyle]="{ padding: '0', borderRadius: '16px', background: 'var(--cardapio-surface, #ffffff)' }"
  (onHide)="onFecharModal()">

  <div class="modal-identificacao">
    <button class="modal-back-btn" type="button" (click)="onFecharModal()">
      <i class="pi pi-arrow-left"></i>
    </button>

    <h3 class="modal-identificacao-titulo">
      {{ 'cardapio_digital.checkout.modal_titulo' | translate }}
    </h3>

    <!-- Seletor de perfis salvos (dropdown) -->
    <div class="perfil-dropdown-campo" *ngIf="perfisCliente.length > 0">
      <div class="perfil-dropdown-label">
        <i class="pi pi-bookmark"></i>
        <span>{{ 'cardapio_digital.carrinho.perfil_salvo' | translate }}</span>
      </div>
      <div class="perfil-dropdown-wrap">
        <select
          class="perfil-select"
          [value]="perfilSelecionadoIndex !== null ? perfilSelecionadoIndex : ''"
          (change)="onDropdownPerfilChange($event)">
          <option value="" *ngIf="perfilSelecionadoIndex === null">{{ 'cardapio_digital.carrinho.perfil_selecionar' | translate }}</option>
          <option
            *ngFor="let perfil of perfisCliente; let i = index"
            [value]="i">
            {{ formatarChipPerfil(perfil) }}
          </option>
        </select>
        <button
          *ngIf="perfilSelecionadoIndex !== null"
          class="perfil-limpar-btn"
          type="button"
          (click)="onNovoPerfil()">
          <i class="pi pi-times"></i>
        </button>
      </div>
    </div>

    <!-- Campo Nome -->
    <div class="modal-identificacao-campo">
      <div class="modal-identificacao-input-wrap">
        <i class="pi pi-user modal-identificacao-icon"></i>
        <input type="text"
               pInputText
               [(ngModel)]="modalNome"
               maxlength="220"
               [placeholder]="'cardapio_digital.checkout.modal_nome' | translate"
               class="modal-identificacao-input" />
      </div>
      <small class="modal-identificacao-erro" *ngIf="nomeCurto">
        {{ 'cardapio_digital.checkout.modal_nome_curto' | translate }}
      </small>
    </div>

    <!-- Campo Telefone -->
    <div class="modal-identificacao-campo modal-telefone-campo">
      <app-phone-input
        [(ddi)]="paisSelecionado"
        [(telefone)]="modalTelefone"
        [placeholder]="'cardapio_digital.checkout.modal_telefone' | translate"
        [autoMask]="true"
        panelStyleClass="ddi-dropdown-panel dropdown-panel-above-modal">
      </app-phone-input>
      <small class="modal-identificacao-erro" *ngIf="telefoneIncompleto">
        {{ 'cardapio_digital.checkout.modal_telefone_incompleto' | translate }}
      </small>
    </div>

    <!-- Radio RUC / CI -->
    <div class="modal-identificacao-campo modo-busca-row">
      <label class="modo-busca-radio">
        <input type="radio" name="modoBusca" value="ruc"
               [(ngModel)]="modoBusca" (ngModelChange)="onModoBuscaChange()" />
        <span>{{ 'cardapio_digital.checkout.modal_ruc_label' | translate }}</span>
      </label>
      <label class="modo-busca-radio">
        <input type="radio" name="modoBusca" value="ci"
               [(ngModel)]="modoBusca" (ngModelChange)="onModoBuscaChange()" />
        <span>{{ 'cardapio_digital.checkout.modal_ci_label' | translate }}</span>
      </label>
    </div>

    <!-- Campo RUC ou CI (opcional, com busca automatica) -->
    <div class="modal-identificacao-campo">
      <div class="modal-identificacao-input-wrap">
        <i class="pi modal-identificacao-icon"
           [ngClass]="{
             'pi-spin pi-spinner': buscandoRuc,
             'pi-check-circle': rucEncontrado && !buscandoRuc,
             'pi-id-card': !buscandoRuc && !rucEncontrado
           }"
           [style.color]="rucEncontrado ? '#22c55e' : 'inherit'"></i>
        <input type="text"
               pInputText
               [value]="modalRuc"
               (input)="onRucInput($event)"
               maxlength="50"
               [placeholder]="(modoBusca === 'ruc' ? 'cardapio_digital.checkout.modal_ruc' : 'cardapio_digital.checkout.modal_ci') | translate"
               class="modal-identificacao-input"
               [class.input-encontrado]="rucEncontrado" />
      </div>
    </div>

    <!-- Mesa e comanda (consumo no local): cada campo so aparece quando a loja o exige. -->
    <div class="modal-identificacao-campo" *ngIf="exigeNumeroDaMesa">
      <div class="modal-identificacao-input-wrap">
        <i class="pi pi-hashtag modal-identificacao-icon"></i>
        <input type="text"
               pInputText
               [(ngModel)]="modalNumeroMesa"
               [placeholder]="'cardapio_digital.checkout.numero_mesa_placeholder' | translate"
               class="modal-identificacao-input" />
      </div>
    </div>

    <div class="modal-identificacao-campo" *ngIf="exigeNumeroDaComanda">
      <div class="modal-identificacao-input-wrap">
        <i class="pi pi-hashtag modal-identificacao-icon"></i>
        <input type="text"
               pInputText
               [(ngModel)]="modalNumeroComanda"
               [placeholder]="'cardapio_digital.checkout.numero_comanda_placeholder' | translate"
               class="modal-identificacao-input" />
      </div>
    </div>

    <!-- Botao Confirmar -->
    <button class="modal-identificacao-btn"
            [disabled]="!modalFormValido"
            (click)="onConfirmarIdentificacao()">
      {{ 'cardapio_digital.checkout.modal_confirmar' | translate }}
    </button>
  </div>
</p-dialog>

<!-- ======================== MODAL DE ENDERECO (DELIVERY) ======================== -->
<p-dialog
  [(visible)]="modalEnderecoVisivel"
  [modal]="true"
  [closable]="true"
  [showHeader]="false"
  styleClass="cardapio-dialog cardapio-dialog-endereco"
  [style]="{ width: 'min(840px, 95vw)', borderRadius: '16px' }"
  [contentStyle]="{ padding: '0', borderRadius: '16px', background: 'var(--cardapio-surface, #ffffff)' }"
  (onHide)="onFecharModalEndereco()">

  <div class="modal-identificacao modal-endereco">
    <button class="modal-back-btn" type="button" (click)="onVoltarEndereco()">
      <i class="pi pi-arrow-left"></i>
    </button>

    <h3 class="modal-identificacao-titulo">
      {{ 'cardapio_digital.checkout.endereco_titulo_modal' | translate }}
    </h3>

    <!-- Layout responsivo: mobile = coluna unica; desktop (>=768px) = 2 colunas -->
    <div class="modal-endereco-layout">

      <!-- COLUNA ESQUERDA: botao localizacao + dica + mapa -->
      <div class="modal-endereco-col-mapa">
        <!-- Botao "Usar minha localizacao" -->
        <button class="btn-minha-localizacao"
                type="button"
                [disabled]="carregandoLocalizacao"
                (click)="onUsarMinhaLocalizacao()">
          <i class="pi" [ngClass]="carregandoLocalizacao ? 'pi-spin pi-spinner' : 'pi-map-marker'"></i>
          <span *ngIf="!carregandoLocalizacao">{{ 'cardapio_digital.checkout.endereco_usar_localizacao' | translate }}</span>
          <span *ngIf="carregandoLocalizacao">{{ 'cardapio_digital.checkout.endereco_carregando_localizacao' | translate }}</span>
        </button>

        <!-- Dica de ajuste do pin -->
        <div class="mapa-endereco-dica">
          {{ 'cardapio_digital.checkout.endereco_ajuste_pin' | translate }}
        </div>

        <!-- Mapa Leaflet -->
        <div class="mapa-endereco-container">
          <div id="map-endereco-leaflet" style="width: 100%; height: 100%;"></div>
        </div>

        <!-- Mensagem de erro de geolocalizacao (inline, nao bloqueante) -->
        <div class="mapa-endereco-erro" *ngIf="erroGeolocalizacao">
          {{ erroGeolocalizacao | translate }}
        </div>
      </div>

      <!-- COLUNA DIREITA: campos + botao confirmar -->
      <div class="modal-endereco-col-campos">
        <!-- Campo Rua/Avenida -->
        <div class="modal-identificacao-campo">
          <label class="modal-endereco-label">{{ 'cardapio_digital.checkout.endereco_rua' | translate }} *</label>
          <div class="modal-identificacao-input-wrap">
            <i class="pi pi-map-marker modal-identificacao-icon"></i>
            <input type="text"
                   pInputText
                   [(ngModel)]="enderecoRua"
                   (keydown.enter)="$event.preventDefault(); buscarEnderecoNoMapa()"
                   [placeholder]="'cardapio_digital.checkout.endereco_placeholder' | translate"
                   class="modal-identificacao-input" />
            <button type="button"
                    class="modal-endereco-buscar-btn"
                    [attr.aria-label]="'cardapio_digital.checkout.endereco_buscar' | translate"
                    [title]="'cardapio_digital.checkout.endereco_buscar' | translate"
                    [disabled]="buscandoEndereco"
                    (click)="buscarEnderecoNoMapa()">
              <i class="pi" [class.pi-search]="!buscandoEndereco" [class.pi-spin]="buscandoEndereco" [class.pi-spinner]="buscandoEndereco"></i>
            </button>
          </div>
        </div>

        <!-- Campo Numero (opcional) -->
        <div class="modal-identificacao-campo">
          <label class="modal-endereco-label">
            {{ 'cardapio_digital.checkout.endereco_numero' | translate }}
            <span class="modal-endereco-opcional">{{ 'cardapio_digital.checkout.endereco_numero_opcional' | translate }}</span>
          </label>
          <div class="modal-identificacao-input-wrap">
            <input type="text"
                   pInputText
                   [(ngModel)]="enderecoNumero"
                   [placeholder]="'cardapio_digital.checkout.endereco_placeholder' | translate"
                   class="modal-identificacao-input" />
          </div>
        </div>

        <!-- Campo Complemento (opcional) -->
        <div class="modal-identificacao-campo">
          <label class="modal-endereco-label">
            {{ 'cardapio_digital.checkout.endereco_complemento' | translate }}
            <span class="modal-endereco-opcional">{{ 'cardapio_digital.checkout.endereco_complemento_opcional' | translate }}</span>
          </label>
          <div class="modal-identificacao-input-wrap">
            <input type="text"
                   pInputText
                   [(ngModel)]="enderecoComplemento"
                   [placeholder]="'cardapio_digital.checkout.endereco_placeholder' | translate"
                   class="modal-identificacao-input" />
          </div>
        </div>

        <!-- Campo Referencia (opcional) -->
        <div class="modal-identificacao-campo">
          <label class="modal-endereco-label">
            {{ 'cardapio_digital.checkout.endereco_referencia' | translate }}
            <span class="modal-endereco-opcional">{{ 'cardapio_digital.checkout.endereco_referencia_opcional' | translate }}</span>
          </label>
          <div class="modal-identificacao-input-wrap">
            <input type="text"
                   pInputText
                   [(ngModel)]="enderecoReferencia"
                   maxlength="500"
                   [placeholder]="'cardapio_digital.checkout.endereco_placeholder' | translate"
                   class="modal-identificacao-input" />
          </div>
        </div>

        <!-- Botao Confirmar Endereco -->
        <button class="modal-identificacao-btn"
                [disabled]="!enderecoFormValido"
                (click)="onConfirmarEndereco()">
          {{ 'cardapio_digital.checkout.endereco_confirmar' | translate }}
        </button>
      </div>

    </div>
  </div>
</p-dialog>
